import App from '@/App.vue'
import i18n from '@/features/locales/i18n'
import { createSentryPiniaPlugin } from '@sentry/vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import { createRouter } from './router/index'

import setupDirectives from '@/plugins/directives'
import setupErrorHandling from '@/plugins/errorHandling'
import setupSvgEvents from '@/plugins/svgEvents'
import setupViewport from '@/plugins/viewport'
import { setConfig } from './utils/config'

const config = await setConfig()

const app = createApp(App)
const pinia = createPinia()
const router = createRouter()

pinia.use(
  createPersistedState({
    key: (id) => `${import.meta.env.VITE_APP_INSTALLATION_TYPE}_${id}`
  })
)

pinia.use(
  createSentryPiniaPlugin({
    stateTransformer: (state) => {
      const transformedState = {
        ...state,
        branded: null,
        designer: undefined,
        knowledgeBase: undefined,
        sandbox: undefined,
        touch: undefined,
        visualiser: undefined
      }
      return transformedState
    }
  })
)

app.use(setupSvgEvents)
app.use(i18n)
app.use(router)
app.use(pinia)

window.logoutPush = false
window.VITE_APP_INSTALLATION_TYPE = import.meta.env.VITE_APP_INSTALLATION_TYPE

setupDirectives(app)
setupErrorHandling(app, router, config)
setupViewport()

app.mount('#app')
